import {
  DatagridConfigurable,
  List,
  SelectInput,
  TextInput,
  TopToolbar,
  FilterButton,
  SelectColumnsButton,
} from 'react-admin';
import { columns } from './ConversionMonitorColumns';
import {
  renderGridColumns,
  renderOmitList,
} from '@/components/ConfigurableColumns';
import { DefaultPagination } from '@/components/DefaultPagination';
import { ConversionMonitorCommandPanel } from './ConversionMonitorCommandPanel';
import { createDateFilters } from '@/util/DateFilters';

const filters = [
  <TextInput key="id" source="id" label="Id" defaultValue="" />,
  <TextInput
    key="firstName"
    source="firstName"
    label="First Name"
    defaultValue=""
  />,
  <TextInput
    key="lastName"
    source="lastName"
    label="Last Name"
    defaultValue=""
  />,
  <TextInput
    key="email"
    source="email"
    label="Email"
    defaultValue=""
  />,
  <SelectInput
    key="violationSeverity_level"
    source="violationSeverity.level"
    label="Severity"
    choices={[
      { id: 'none', name: 'None' },
      { id: 'acceptable', name: 'Acceptable' },
      { id: 'moderate', name: 'Moderate' },
      { id: 'critical', name: 'Critical' },
    ]}
  />,
  <SelectInput
    key="conversionStatus_status"
    source="conversionStatus.status"
    label="Conversion Status"
    choices={[
      { id: 'trial-completed', name: 'Trial Completed' },
      { id: 'subscribed', name: 'Subscribed' },
    ]}
  />,
  <SelectInput
    key="isLifelongTrial"
    source="isLifelongTrial"
    label="Lifelong Trial"
    choices={[
      { id: 'visible', name: 'Visible' },
      { id: 'hidden', name: 'Hidden' },
      { id: 'only', name: 'Only' },
    ]}
  />,
  ...createDateFilters('createdAt', 'Created'),
];

const ListActions = () => (
  <TopToolbar>
    <FilterButton />
    <SelectColumnsButton />
  </TopToolbar>
);

export const ConversionMonitorList = () => (
  <List
    actions={<ListActions />}
    filters={filters}
    pagination={<DefaultPagination />}
    perPage={50}
  >
    <DatagridConfigurable
      bulkActionButtons={false}
      expand={ConversionMonitorCommandPanel}
      omit={renderOmitList(columns)}
      sx={{
        '& .MuiTableCell-root': {
          whiteSpace: 'nowrap',
        },
      }}
    >
      {renderGridColumns(columns)}
    </DatagridConfigurable>
  </List>
);
